import { Box, type SxProps } from '@mui/material';
import type { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import { type FC, type ReactNode } from 'react';

type TEmblaScrollContainerProps = {
  children: ReactNode;
  gap?: number;
  options?: EmblaOptionsType;
  itemSx?: SxProps;
};

export const EmblaScrollContainer: FC<TEmblaScrollContainerProps> = ({ children, gap = 3, options, itemSx }) => {
  const [emblaRef] = useEmblaCarousel({ align: 'start', containScroll: 'trimSnaps', dragFree: true, ...options });

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Box ref={emblaRef} sx={{ mx: { xs: 5, lg: 0 } }}>
        <Box sx={{ display: 'flex', gap, ...(itemSx && { '& > *': itemSx }) }}>{children}</Box>
      </Box>
    </Box>
  );
};
